import PhoneInputWithCountryCode from "../../../../../common/PhoneInputWithCountryCode";
import {minSymbolsForNumberValidation, phoneNumberRegex} from "../../../../../../consts";
import React from "react";

export default function ContactInfoControlForm({ control,
                                                 isContactInfoRequiredByRadioGroupOptions,
                                                 setContactInfo,
                                                 contactInfo }) {

    const isRequiredInput = () => control.IsRequired || isContactInfoRequiredByRadioGroupOptions;

    const placeholderRequiredFormatter = (text) => {
        return (isRequiredInput() ? `${text}*` : text);
    }

    const isValidPhoneNumber = (value) => {
        if((!isRequiredInput() && value.length > minSymbolsForNumberValidation) || isRequiredInput()) {
            return phoneNumberRegex.test(value)
        }
        else {
            return true
        }
    }

    return (
        <>
            <input
                id="contact-info-first-name"
                key="contact-info-first-name"
                className="input__container input text_default"
                placeholder={placeholderRequiredFormatter("First Name")}
                onChange={e => setContactInfo({ ...contactInfo, firstName: e.target.value })}
                value={contactInfo.firstName}
            />
            <input
                id="contact-info-last-name"
                key="contact-info-last-name"
                className="input__container input text_default"
                placeholder={placeholderRequiredFormatter("Last Name")}
                onChange={e => setContactInfo({ ...contactInfo, lastName: e.target.value })}
                value={contactInfo.lastName}
            />
            <input
                key="contact-info-email"
                className="input__container input text_default"
                placeholder="Email"
                onChange={e => setContactInfo({ ...contactInfo, email: e.target.value })}
                value={contactInfo.email}
            />
            <PhoneInputWithCountryCode
                key="contact-info-phone-number"
                placeholder={placeholderRequiredFormatter("Phone Number")}
                enableSearch={true}
                country={"us"}
                onChange={value => setContactInfo({ ...contactInfo, phoneNumber: `+${value}` })}
                value={contactInfo.phoneNumber}
                isValid={(value) => isValidPhoneNumber(value)}
            />
        </>
    )
}